import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import BTooltip from "../../../../components/b-tooltip";
import BSkeleton from "../../../../components/b-skeleton";
import AddressName from "../../../common/address-name";
import {formatNumber} from "../../../../common/utils/function";
import useCommon from "../../../../common/hooks/useCommon";
import TokenImage from "../../../common/token-image";

interface TransferProps {
    list: any[];
    loading?: boolean;
    transaction?: any
}

const TransactionAction: FC<TransferProps> = (props) => {
    const {t} = useTranslation();
    const {get0x} = useCommon();

    if (!props?.list?.length) return null;

    return (
        <React.Fragment>
            <div className="bs-list-row">
                <div className="bs-list-title">
                    <BTooltip text={t("Highlighted events of the transaction.")}>
                        <i className="bi bi-lightning-charge-fill bs-font-primary me-2"></i>
                    </BTooltip>
                    {t("Transaction Action")}:
                </div>
                <div className="bs-list-content">
                    {props?.loading ? <BSkeleton/> : (
                        props?.list.map((item, index) => (
                            <p key={index} className="d-flex align-items-center">
                                {item.summary_template.split(/({[^}]+})/g).map((part: any, i: number) => {
                                    if (part.match(/{[^}]+}/)) {
                                        const key = part.slice(1, -1);
                                        const value = item?.summary_template_variables?.[key]?.value;
                                        const type = item?.summary_template_variables?.[key]?.type;

                                        if (type === 'address') {
                                            return (<Link key={i} to={value.hash} className="me-1"><AddressName data={value}/></Link>);
                                        } else if (type === 'token') {
                                            return (
                                                <Link key={i} to={`/token/${get0x(value?.address)}`} className="d-flex align-items-center me-1">
                                                    <TokenImage image={value?.icon_url} symbol={value?.symbol} params={{width: 20, className: "me-1"}}/>
                                                    {value?.name} ({value?.symbol})
                                                </Link>
                                            );
                                        } else if (type === 'currency') {
                                            return (<span key={i} className="me-1">{formatNumber(value)}</span>);
                                        } else if (key === 'native') {
                                            return (<Link key={i} to={props?.transaction?.from?.hash} className="me-1"><AddressName data={props?.transaction?.from}/></Link>);
                                        } else {
                                            return (<span key={i} className="me-1">{value}</span>);
                                        }
                                    }
                                    return part;
                                })}
                            </p>
                        ))
                    )}
                </div>
            </div>
            <hr/>
        </React.Fragment>
    );
};

export default TransactionAction;
